import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class GroupedItem extends BaseModel {

  rules = {
  };

  attributeHints = {};

  attributeLabels = {
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
